import React from 'react'
import { Table } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'

const UsersListComponent = ({ data, onSelect }) => (
  <div>
    {data && data.length ? (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Email</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Is Active</th>
            <th>Groups</th>
            <th>Date Joined</th>
            <th>Last Login</th>
          </tr>
        </thead>
        <tbody>
          {data.map((s, i) => (
            <tr style={{ cursor: 'pointer' }} key={i} onClick={() => onSelect(s)}>
              <td>{s.email}</td>
              <td>{s.first_name}</td>
              <td>{s.last_name}</td>
              <td>{s.is_active ? <i className='fa fa-check' /> : <i className='fa fa-minus' />}</td>
              <td>
                {s.groups
                  .split(',')
                  .filter((g) => !!g)
                  .map((group, index) => (
                    <span style={{ marginRight: '1px' }} key={index} className={'label label-success'}>
                      {group}
                    </span>
                  ))}
              </td>
              <td>{formatTimeString(s.date_joined)}</td>
              <td>{s.last_login ? formatTimeString(s.last_login) : s.last_login}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <span>{'N/A'}</span>
    )}
  </div>
)

export default UsersListComponent
